import { AbstractAIHelperDialogService } from '../../../Common/Dialogs/services/abstract-AI-helper-dialog.service';
import { AiFormatConfigModel } from '../../../Common/Dialogs/models/AI-helper-dialog-config.model';
import { Injectable } from '@angular/core';
import { CompletionFormatEnum } from '../../../api/ai/enums/completion-format.enum';
import { DropdownOptionModel } from '../../../Common/Forms/models/dropdown-option.model';

@Injectable()
export class DistributionAIHelperDialogService extends AbstractAIHelperDialogService {
    getConfig(): AiFormatConfigModel {
        return {
            showFormat: true,
            defaultFormat: CompletionFormatEnum.PRESS_RELEASE_DISTRIBUTION,
            formatOptions: [
                new DropdownOptionModel('Common.dialog.aiHelper.pressReleaseFormat.pressRelease', CompletionFormatEnum.PRESS_RELEASE_DISTRIBUTION),
                new DropdownOptionModel('Common.dialog.aiHelper.pressReleaseFormat.email', CompletionFormatEnum.EMAIL),
            ]
        };
    }
}
